var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#989898",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00032 6.93562L9.97309 4.91581C10.171 4.71162 10.2998 4.70952 10.5013 4.91581L10.8971 5.32114C11.091 5.51962 11.1041 5.6499 10.8971 5.8619L8.80851 8L10.8973 10.1381C11.0929 10.339 11.0967 10.4747 10.8973 10.679L10.5015 11.0842C10.2961 11.2945 10.1693 11.2848 9.97328 11.0842L8.00032 9.06438L6.02756 11.084C5.83156 11.2846 5.70471 11.2943 5.49937 11.084L5.10356 10.6789C4.90394 10.4745 4.90756 10.3389 5.10356 10.1379L7.19213 8L5.10356 5.8619C4.89652 5.6499 4.90756 5.51962 5.10356 5.32114L5.49918 4.91581C5.69899 4.70952 5.82775 4.71162 6.02737 4.91581L8.00032 6.93562Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossFilled);
export default __webpack_public_path__ + "static/media/cross-filled.2ceecb88.svg";
export { ForwardRef as ReactComponent };